'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = Link;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Link Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function Link(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$href = props.href,
        href = _props$href === undefined ? '' : _props$href,
        _props$title = props.title,
        title = _props$title === undefined ? '' : _props$title,
        _props$target = props.target,
        target = _props$target === undefined ? '' : _props$target,
        _props$rel = props.rel,
        rel = _props$rel === undefined ? '' : _props$rel;


    return (0, _jsx3.default)('a', {
        href: href,
        rel: rel,
        title: title,
        target: target,
        className: '' + className,
        id: id
    }, void 0, props.children);
}
//# sourceMappingURL=Link.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/link/Link.js
// module id = 575
// module chunks = 0